// Sommelier da Konvém (18/10/2026): a conversa que abre pelo cartão das páginas de vinho (snippets/kv-sommelier.liquid).
// Atalhos (situação x quanto gastar) = respostas prontas do servidor (GET /atalhos), sem custo por cliente.
// Pergunta escrita = POST /perguntar (Sonnet), com Turnstile e as travas do servidor (3 por conversa, 2 conversas
// por aparelho por dia, teto de gasto do dia). "Pôr na sacola" usa window.kvCesta (assets/konvem.js): a sacola com
// gelo é o atributo do carrinho "Embalagem com gelo" = "Sim" (como na página do produto, assets/kv-gelo.js) e a de
// presente é a propriedade "Presente" da linha (como em konvem.js).
(() => {
  const raiz = document.querySelector('[data-kv-som]');
  if (!raiz) return;
  const T = JSON.parse(raiz.querySelector('[data-kv-som-textos]').textContent);
  const API = raiz.dataset.api, SITEKEY = raiz.dataset.sitekey;
  raiz.querySelectorAll('[data-kv-som-t]').forEach((e) => { e.textContent = T[e.dataset.kvSomT] || ''; });

  const brl = (n) => n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const novoId = () => Math.random().toString(36).slice(2) + Date.now().toString(36);
  let aparelho = null;
  try { aparelho = localStorage.getItem('kvSomAparelho') || novoId(); localStorage.setItem('kvSomAparelho', aparelho); } catch (e) { aparelho = novoId(); }
  const conversa = novoId();
  const TACA = raiz.querySelector('.kv-som__taca').innerHTML;

  let folha, veu, chat, campo, enviar, conta, tsBox, dados = null, escritas = 0, historico = [], ocupado = false, comGelo = false, ultimoFoco = null;
  let tsPronto = null, tsWidget = null, tsToken = '';

  function el(tag, cls, txt) { const e = document.createElement(tag); if (cls) e.className = cls; if (txt !== undefined) e.textContent = txt; return e; }
  // Ritmo de conversa (Paulo, 18/10): cada parte da resposta chega depois dos pontinhos de "digitando", e a tela
  // desce só o necessário para mostrar o que chegou, sem passar do começo dele (o cliente lê o texto antes das fotos).
  const calmo = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const espera = (ms) => new Promise((r) => setTimeout(r, calmo ? Math.min(ms, 250) : ms));
  function mostrar(e) {
    const alvo = Math.min(e.offsetTop + e.offsetHeight + 12 - chat.clientHeight, e.offsetTop - 12);
    if (alvo > chat.scrollTop) chat.scrollTo({ top: alvo, behavior: calmo ? 'auto' : 'smooth' });
  }
  const msg = (t, quem) => { const e = el('div', 'kv-som-m kv-som-m--' + quem, t); chat.appendChild(e); mostrar(e); return e; };
  function digitando() {
    const d = el('div', 'kv-som-m kv-som-m--s kv-som-digita'); d.setAttribute('aria-label', T.chat_nome + ' está digitando');
    d.append(el('i'), el('i'), el('i')); chat.appendChild(d); mostrar(d); return d;
  }
  // Ritmo (Paulo, 18/10: "ainda muito rápido, vai jogando um por um"): os pontinhos duram como quem digita de verdade.
  async function falar(t, quem = 's') { const d = digitando(); await espera(Math.min(3500, 1000 + t.length * 22)); d.remove(); const e = msg(t, quem); e.classList.add('kv-som-entra'); return e; }
  async function entrar(no, pausa = 2000) { const d = digitando(); await espera(pausa); d.remove(); no.classList.add('kv-som-entra'); chat.appendChild(no); mostrar(no); }
  function chips(lista, fn) {
    const w = el('div', 'kv-som-chips kv-som-entra');
    lista.forEach(([k, n]) => { const b = el('button', '', n); b.type = 'button'; b.onclick = () => { w.remove(); fn(k, n); }; w.appendChild(b); });
    chat.appendChild(w); mostrar(w);
  }

  function montar() {
    veu = el('div', 'kv-som-veu');
    folha = el('div', 'kv-som-folha');
    folha.setAttribute('role', 'dialog'); folha.setAttribute('aria-modal', 'true'); folha.setAttribute('aria-label', T.chat_nome);
    const cab = el('div', 'kv-som-cab');
    const taca = el('span', 'kv-som__taca'); taca.innerHTML = TACA;
    const nome = el('div'); nome.appendChild(el('b', '', T.chat_nome)); nome.appendChild(el('small', '', T.chat_sub));
    const fecha = el('button', 'kv-som-fecha', '✕'); fecha.type = 'button'; fecha.setAttribute('aria-label', T.fechar); fecha.onclick = fechar;
    cab.append(taca, nome, fecha);
    chat = el('div', 'kv-som-chat');
    const form = el('form', 'kv-som-form');
    campo = el('input'); campo.maxLength = 200; campo.placeholder = T.campo; campo.setAttribute('aria-label', T.campo); campo.enterKeyHint = 'send';
    enviar = el('button', '', T.enviar); enviar.type = 'submit';
    form.append(campo, enviar);
    form.onsubmit = (ev) => { ev.preventDefault(); perguntar(); };
    campo.addEventListener('focus', carregarTurnstile, { once: true });
    tsBox = el('div', 'kv-som-ts');
    conta = el('div', 'kv-som-conta');
    folha.append(cab, chat, tsBox, form, conta);
    veu.onclick = fechar;
    document.body.append(veu, folha);
    folha.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') fechar(); });
  }

  const MAX = 15;   // perguntas escritas por conversa (o servidor confere); o número não aparece para o cliente
  function contar() { conta.textContent = escritas >= MAX ? T.limite : ''; campo.disabled = enviar.disabled = escritas >= MAX || ocupado; }

  async function carregarDados() {
    if (dados) return dados;
    const r = await fetch(API + '/atalhos');
    if (!r.ok) throw new Error('atalhos ' + r.status);
    dados = await r.json();
    return dados;
  }
  const situacoes = () => dados.situacoes.filter(([k]) => dados.respostas.some((r) => r.situacao === k)).map(([k, n]) => [k, (T.situacoes || {})[k] || n]);
  const faixas = (s) => dados.faixas.filter(([k]) => dados.respostas.some((r) => r.situacao === s && r.faixa === k)).map(([k, n]) => [k, (T.faixas || {})[k] || n]);

  function avisar(texto) {
    chat.querySelectorAll('.kv-som-toast').forEach((x) => x.remove());
    const t = el('div', 'kv-som-toast'); t.appendChild(el('span', '', texto));
    const b = el('button', '', T.ver_carrinho); b.type = 'button';
    b.onclick = () => { fechar(); if (window.kvCesta && window.kvCesta.abrirCesta) window.kvCesta.abrirCesta(true); else location.href = '/cart'; };
    t.appendChild(b); chat.appendChild(t); mostrar(t);
  }

  async function porNaSacola(v, levar, botao) {
    botao.disabled = true;
    try {
      const props = levar === 'presente' ? { Presente: 'Na sacola de presente (grátis)' } : {};
      const C = window.kvCesta;
      if (levar === 'gelo') {
        comGelo = true;
        if (C) await C.postar('cart/update.js', { attributes: { 'Embalagem com gelo': 'Sim' } });
        else await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Embalagem com gelo': 'Sim' } }) });
      }
      if (C && C.adicionar) await C.adicionar([{ id: v.variante, quantity: 1, properties: props }], { abrir: false });
      else await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.variante, quantity: 1, properties: props }] }) });
      botao.textContent = T.botao_ok; botao.classList.add('is-ok');
      avisar((levar === 'gelo' ? T.aviso_gelo : levar === 'presente' ? T.aviso_presente : T.aviso_comum).replace('{vinho}', v.curto));
    } catch (e) { botao.disabled = false; msg(T.erro, 's kv-som-m--p'); }
  }

  function cartao(id, porque, rotulo, grande, clima) {
    const v = dados.vinhos[id] || (ultimaResposta && ultimaResposta.vinhos && ultimaResposta.vinhos[id]);
    if (!v) return null;
    const c = el('div', 'kv-som-vc' + (grande ? ' kv-som-vc--big' : ''));
    const img = el('img'); img.alt = v.nome; img.loading = 'lazy'; img.src = v.foto || '';
    const corpo = el('div', 'kv-som-vc__c');
    const nome = el('a', 'kv-som-vc__n', v.nome); nome.href = v.url;
    corpo.append(el('span', 'kv-som-rot', rotulo), nome, el('span', 'kv-som-vc__p', brl(v.preco)), el('span', 'kv-som-vc__q', porque || ''));
    const ops = [['comum', T.levar_comum]];
    if (v.gelo) ops.push(['gelo', T.levar_gelo]);
    if (v.presente) ops.push(['presente', T.levar_presente]);
    // 18 °C ou mais (o servidor diz): branco, rosé e espumante já vêm na sacola com gelo; o tinto fica na comum
    let levar = clima && clima.gelo && v.gelo && v.tipo && v.tipo !== 'Vinhos Tintos' ? 'gelo' : 'comum';
    if (ops.length > 1) {
      const w = el('div', 'kv-som-levar');
      ops.forEach(([k, n]) => { const b = el('button', '', n); b.type = 'button'; b.setAttribute('aria-pressed', k === levar); b.onclick = () => { levar = k; w.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', x === b)); }; w.appendChild(b); });
      corpo.appendChild(w);
    }
    const por = el('button', 'kv-som-por', T.botao_sacola); por.type = 'button';
    por.onclick = () => porNaSacola(v, levar, por);
    corpo.appendChild(por);
    c.append(img, corpo);
    return c;
  }

  let ultimaResposta = null;
  async function indicacao(r, clima) {
    ultimaResposta = r;
    if (r.abertura) { await falar(r.abertura); await espera(700); }
    for (const [k, rot, grande] of [['principal', T.rot_principal, true], ['em_conta', T.rot_conta], ['especial', T.rot_especial]]) {
      const c = r[k] && cartao(r[k].id, r[k].porque, rot, grande, clima);
      if (c) { await entrar(c, grande ? 2200 : 2000); await espera(1200); }   // tempo de ler o vinho antes do próximo
    }
    if (r.dica) await falar(r.dica);
  }

  async function situacao(k, n) {
    msg(n, 'c');
    await falar(T.preco);
    chips(faixas(k), async (fk, fn) => {
      msg(fn, 'c');
      const r = dados.respostas.find((x) => x.situacao === k && x.faixa === fk);
      if (r) await indicacao(r, dados.clima);
      await espera(600); await falar(T.outra); chips(situacoes(), situacao);
    });
  }

  function carregarTurnstile() {
    if (tsPronto || !SITEKEY) return tsPronto;
    tsPronto = new Promise((ok) => {
      window.kvSomTs = () => {
        tsWidget = window.turnstile.render(tsBox, { sitekey: SITEKEY, appearance: 'interaction-only', callback: (t) => { tsToken = t; }, 'expired-callback': () => { tsToken = ''; } });
        ok();
      };
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=kvSomTs'; s.async = true;
      s.onerror = () => ok();
      document.head.appendChild(s);
    });
    return tsPronto;
  }
  async function tokenTurnstile() {
    await carregarTurnstile();
    for (let i = 0; i < 40 && !tsToken; i++) await new Promise((r) => setTimeout(r, 250));
    const t = tsToken; tsToken = '';
    if (window.turnstile && tsWidget !== null) window.turnstile.reset(tsWidget);
    return t;
  }

  async function perguntar() {
    const t = campo.value.trim();
    if (!t || ocupado || escritas >= MAX) return;
    ocupado = true; contar(); campo.value = '';
    msg(t, 'c');
    const pensa = digitando();
    try {
      const r = await fetch(API + '/perguntar', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ aparelho, conversa, pergunta: t, historico, turnstile: await tokenTurnstile() }) });
      const j = await r.json().catch(() => ({}));
      pensa.remove();
      if (r.ok) {
        escritas++;
        dados.vinhos = Object.assign({}, dados.vinhos, j.vinhos || {});
        await indicacao(j, j.clima || dados.clima);
        historico.push({ p: t, r: [j.abertura, ...['principal', 'em_conta', 'especial'].filter((k) => j[k]).map((k) => (j.vinhos[j[k].id] || {}).nome + ': ' + j[k].porque), j.dica].filter(Boolean).join('\n') });
      } else if (j.erro === 'conversa') { escritas = MAX; }
      else if (j.erro === 'dia' || j.erro === 'teto') { escritas = MAX; msg(T.limite_dia, 's'); }
      else if (j.erro === 'robo') msg(T.robo, 's kv-som-m--p');
      else msg(T.erro, 's kv-som-m--p');
    } catch (e) { pensa.remove(); msg(T.erro, 's kv-som-m--p'); }
    ocupado = false; contar();
  }

  async function abrir() {
    if (!folha) montar();
    ultimoFoco = document.activeElement;
    document.documentElement.classList.add('kv-som-trava');
    veu.hidden = false; folha.hidden = false;
    requestAnimationFrame(() => { veu.classList.add('is-on'); folha.classList.add('is-on'); });
    if (!chat.childElementCount) {
      const carga = carregarDados();
      await espera(300);
      await falar(T.saudacao);
      try { await carga; chips(situacoes(), situacao); } catch (e) { msg(T.erro, 's kv-som-m--p'); }
    }
    contar();
    setTimeout(() => folha.querySelector('.kv-som-fecha').focus(), 300);
  }
  function fechar() {
    veu.classList.remove('is-on'); folha.classList.remove('is-on');
    if (document.activeElement === campo) campo.blur();
    setTimeout(ajustarTeclado, 300);
    document.documentElement.classList.remove('kv-som-trava');
    setTimeout(() => { veu.hidden = true; }, 250);
    if (comGelo && window.kvCesta && window.kvCesta.abrirCesta) { comGelo = false; window.kvCesta.abrirCesta(true); }   // a gaveta acerta a sacola com gelo
    else if (ultimoFoco) ultimoFoco.focus();
  }
  // Teclado do celular (iPhone, 18/10): o Safari encolhe só a área visível e empurra a página; a folha presa ao fundo
  // ficava no meio, com a página aparecendo por baixo. Aqui a folha acompanha a área visível: com teclado, ocupa tudo
  // acima dele e mostra as últimas mensagens; sem teclado, volta aos 88% da altura.
  function ajustarTeclado() {
    const vv = window.visualViewport;
    if (!vv || !folha) return;
    if (!folha.classList.contains('is-on') || window.innerWidth >= 750) { folha.style.top = folha.style.height = folha.style.bottom = ''; return; }
    const teclado = window.innerHeight - vv.height > 120;
    const h = Math.round(teclado ? vv.height : vv.height * 0.88);
    folha.style.height = h + 'px';
    folha.style.bottom = 'auto';
    folha.style.top = Math.round(vv.offsetTop + vv.height - h) + 'px';
    if (teclado && document.activeElement === campo) chat.scrollTop = chat.scrollHeight;
  }
  if (window.visualViewport) { visualViewport.addEventListener('resize', ajustarTeclado); visualViewport.addEventListener('scroll', ajustarTeclado); }
  raiz.querySelector('[data-kv-som-abrir]').addEventListener('click', () => { abrir(); requestAnimationFrame(ajustarTeclado); });
})();
